import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import React, {useEffect, useRef, useState} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import EmailVerificationImg from '../../src/assets/Images/CommonImages/email_verification.png';
import VerificationInput from "react-verification-input";
import APICom from "../utils/helpers/APICom.js";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { Calendar } from 'primereact/calendar';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { format } from 'date-fns';
import Form from 'react-bootstrap/Form';
import validator from 'validator'
import CircleRow from "../components/common/circles.js";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import AddressSearch from "../components/Controls/AddressSearch.js";


const DemoMTSchedulerSignupProcess = (props) => {
    
    const SimulationDashboardURL = "https://demo1rmdashboard.itcurves.us/index.html?username=ncs&password=oOFPtMQKKhc=&webmrms=true"; 
    const timeoutId = useRef();
    const [selectedVehiclesCount, setSelectedVehicleCount] = useState(0);
    const [selectedTripsPerVehiclesCount, setSelectedTripsPerVehiclesCount] = useState(0);
    const [tspid, setTspId] = useState(-1);
    const [serviceLat, setServiceLat] = useState("");
    const [serviceLong, setServiceLong] = useState("");
    const [latLngFromChildAddressComponent, setLatLngFromChildAddressComponent] = useState("");
    function getLatLongDataFromChildAddressComponent(data) {
        setLatLngFromChildAddressComponent(data);
      }

    const [desiredMilesValue, setDesiredMilesValue] = useState(30);
    const [pickupAddr2, setPickupAddr] = useState("");

    // Handler for the input's onChange event
    const handlePUAddrChanged = (e) => {
        if(e?.target?.value || "")
        {
            setPickupAddr(e.target.value);
        }
    };

    const [userMessage, setUserMessage] = useState("");
    const [isUserAlreadySignedUp, setIsUserAlreadySignedUp] = useState(false);
    const [loading, setLoading] = useState(true);
    const rczManagementUIApplied = useRef(false);
    const backButtonPressed = useRef(false);
    const handleNextRef = useRef(null);
    const triggerNextStep = () => {
        if (handleNextRef.current) {
            backButtonPressed.current = false;
            handleNextStep(handleNextRef.current)
            //handleNextRef.current();
        }
    };

    const handlePrevRef = useRef(null);
    const triggerPrevStep = () => {
        if (handlePrevRef.current) {
            backButtonPressed.current = true;
            handleNextStep(handlePrevRef.current)
        }
    };

    const testRCZScreen = "https://sivmarsdashboard.itcurves.us/web/common/rcz.html?tspid=125&user=ncs&userid=46&isinloadmode=true"//"http://localhost:21461/web/common/rcz.html?tspid=125&user=ncs&userid=46&isinloadmode=true";
    const productionRCZScreen = "https://marsdashboard.itcurves.us/web/common/rcz.html?tspid=125&user=ncs&userid=46&isinloadmode=true";
    const [footerClass, setFooterClass] = useState("p-0 px-2 py-1");
    const [outerDivClass, setOuterDivClass] = useState("setOuterDivDefault")
    const {GlobalASCSData} = useSelector((store) => store.combinedata);
    const RCZManagementScreenURL = testRCZScreen; //GlobalASCSData.find(item => item.SubTitle === "RCZManagementScreenURL").value; 
    const [modalClass, setModalClass] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [showDemoMTSchedulerhDialog, setShowDemoMTSchedulerhDialog] = useState(false);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [website, setWebsite] = useState("");
    const [comments, setComments] = useState("");
    const [prevIndex, setPrevIndex] = useState("0");
    const [nextIndex, setNextIndex] = useState("1");
    const [verificationCode, setVerificationCode] = useState("");
    const [demoUserRecordID, setDemoUserRecordID] = useState("");
    const [slotDuration, setSlotDuration] = useState("30");
    const [selectedTime, setSelectedTime] = useState(null);
    const [verificationCodeInput, setVerificationCodeInput] = useState("");
    const [date, setDate] = useState(new Date());
    const [cityOptions, setCityOptions] = useState([]);
    const [countyOptions, setCountyOptions] = useState([]);
    const [cityCountyOption, setCityCountyOption] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [timeSlotsData, setTimeSlotsData] = useState([]);
    const [boundary, setBoundary] = useState('city');
    const [selectedState, setSelectedState] = useState('');
    const xCancelSourceForGrid = useRef(null);
    const today = new Date();
    const [moveToEmail, setMoveToEmail] = useState(false);
    xCancelSourceForGrid.current = APICom.GenerateSource();

    const [modalFooterHTML, setModalFooterHTML] = useState();

    const handleDemoMTSchedulerLoginDialogClose = () => {
        if (props.showDemoMTSchedulerSignupProcess) {
            clearTimeout(timeoutId.current);
            props.setShowDemoMTSchedulerSignupProcess(false);
        }
    }

    let citiesOptions = [];
    let countiesOptions = [];
    let statesGlobalOptions = [];

    async function fetchCityData(state) {
        citiesOptions =[]
        try {
            const response = await APICom.fetchData("main", "SimulationScheduler/GetCities?state=" + state, "get", {}, {}, xCancelSourceForGrid.current)
            response.data.forEach(item => {
                citiesOptions.push({value: item.Geocity, label: item.Geocity + ", " + item.geostate});
            });
            setCityOptions(citiesOptions);
            return citiesOptions
        } catch (error) {
            console.error('Error fetching city data:', error);
        }
    };

    async function fetchCountyData(state) {
        countiesOptions = []
        try {
            const response = await APICom.fetchData("main", "SimulationScheduler/GetCounties?state=" + state, "get", {}, {}, xCancelSourceForGrid.current)
            response.data.forEach(item => {
                countiesOptions.push({value: item.geoCounty, label: item.geoCounty + ", " + item.geostate});
            });
            setCountyOptions(countiesOptions);
            return countiesOptions
        } catch (error) {
            console.error('Error fetching city data:', error);
        }
    };

    async function fetchStateData() {
        try {
            const response = await APICom.fetchData("main", "SimulationScheduler/GetStates", "get", {}, {}, xCancelSourceForGrid.current)
            response.data.forEach(item => {
                statesGlobalOptions.push({value: item.geoState, label: item.geoState});
            });
            setStateOptions(statesGlobalOptions);
            if (statesGlobalOptions.length > 0) {
                setSelectedState(statesGlobalOptions[0].value);
                return statesGlobalOptions[0].value
            }
        } catch (error) {
            console.error('Error fetching city data:', error);
        }
    };

    async function fetchTimeSlots(date_param) {
        let demoDate;
        if(date_param){
            demoDate = date_param
        }else {
            demoDate = date
        }
        let timeslotsArr = []
        try {
            const response = await APICom.fetchData("main", "SimulationScheduler/GetDemoTimeSlots?demoDate=" + format(demoDate, 'MM/dd/yyyy'), "get", {}, {}, xCancelSourceForGrid.current)
            response.data.forEach(item => {
                timeslotsArr.push(item.Slot);
            });
            setTimeSlotsData(timeslotsArr);
            return timeslotsArr
        } catch (error) {
            console.error('Error fetching city data:', error);
        }
    };

    useEffect( () => {
        async function wrapperfetchTimeSlots() {
            let timeSlotDataArr = await fetchTimeSlots('');
            let stl_state = await fetchStateData();

            setStateOptions(statesGlobalOptions)
            let cit_opt = await fetchCityData(stl_state)
            let cnt_opt  = await fetchCountyData(stl_state)
            setSelectedState(stl_state);
            if (boundary === 'city'){
                setCityCountyOption(cit_opt)
            }else{
                setCityCountyOption(cnt_opt)
            }
        }
        //wrapperfetchTimeSlots();
    }, []);



    const handleBoundaryChange = (e) => {
        let boundary_val = e.target.value
        setBoundary(boundary_val);
        let selectedOption;
        if (boundary_val === 'city'){
            selectedOption = cityOptions
        }else{
            selectedOption = countyOptions
        }
        setCityCountyOption(selectedOption)
    };

    const handleStateChange = async (e) => {
        let state_val = e.target.value
        let cit_opt = await fetchCityData(state_val)
        let cnt_opt  = await fetchCountyData(state_val)
        setSelectedState(state_val);
        if (boundary === 'city'){
            setCityCountyOption(cit_opt)
        }else{
            setCityCountyOption(cnt_opt)
        }
    };

    const handleCalenderDateChange = async (e) => {
        let date_val = e.target.value
        setDate(date_val)
        let timeSlotDataArr = await fetchTimeSlots(date_val)
        setTimeSlotsData(timeSlotDataArr);
        console.log(timeSlotDataArr)
    };

    const handleComplete = () => {
        updateSimulationTimes();
    };

    const handleTabChange = ({ prevIndex, nextIndex }) => {
        
        setPrevIndex(prevIndex);
        setNextIndex(nextIndex);
        if(prevIndex == 4 && nextIndex == 5 && backButtonPressed.current == true){
            setUISettingsForRCZManagementScreen();
        }
      };

      const backTemplate = (handlePrevious) => {
        handlePrevRef.current = handlePrevious;
        backButtonPressed.current = true;
        return (
          <button className="base-button " onClick={handlePrevious}>
            Back
          </button>
        );
      };

    const handleSelect = (time) => {
        alert(date)
        setSelectedTime(time);
    };

    const checkValidateTab = async () => {
        let  tenDigitNumberPattern = /^\d{10}$/;
        let isPhoneValid = tenDigitNumberPattern.test(phone);
        let isEmailValid = validator.isEmail(email);
        if (firstName && lastName && email && phone ){
            if (!isPhoneValid) {
                return "Enter Valid Phone Number"
            } else if (!isEmailValid) {
                return "Enter Valid Email"
            } else {
                return "true"
            }
        }
        else{
            return "Please fill in the required fields"
        }
    };

    const errorMessages = (msg) => {
        if(msg){
            alert(msg);
        }else {
            alert("Please fill in the required fields");
        }
    };

    const handleDemoTimechange = async (e) => {
        let state_val = e.target.value
        let timeslotsArr = []
        timeslotsArr.push(parseInt(state_val));
        setTimeSlotsData(timeslotsArr);
        setSelectedTime(state_val);
    };

    const handleDemoNoOfVehicles = async (e) => {
        let state_val = e.target.value
        setSelectedVehicleCount(parseInt(state_val));
    };

    const handleDemoNoOfTripsPerVehicle = async (e) => {
        let state_val = e.target.value
        setSelectedTripsPerVehiclesCount(parseInt(state_val));
    };



    const handleNextStep = async (handleNext) => {     
        setUserMessage("");
        if (prevIndex == 0 && nextIndex == 1) {
            const isValid = await checkValidateTab();
            if (isValid !== "true") {
                errorMessages(isValid);
            } else {
                let data = {
                    "vFirstName": firstName,
                    "vLastName": lastName,
                    "vEmail": email,
                    "vPhone": phone,
                    "vCompanyName": companyName,
                    "vURL": website,
                    "vNotes": comments
                }
                let response = await APICom.fetchData("main", "SimulationScheduler/SaveDemoUserRegistration", "post", {}, data, xCancelSourceForGrid.current)
                setVerificationCode(response.data[0].verificationCode.toString());
                setDemoUserRecordID(response.data[0].NewRecordID.toString());
                if(response.data[0].verificationCode.toString() == "-1" && response.data[0].NewRecordID.toString() == "-1"){
                    setIsUserAlreadySignedUp(true);
                    setUserMessage("You are already registered, please singin to proceed.");
                }
                else{
                    setUserMessage("");
                    handleNext();
                }
            }
        }
        else if(prevIndex == 1 && nextIndex == 2){
            handleNext();
            if(verificationCode !== verificationCodeInput){
                errorMessages("Invalid Code")
            }else {
                let data = {
                    "recordID": demoUserRecordID,
                    "bPhoneCodeVerified": true,
                    "bEmailCodeVerified": true
                }
                let response = await APICom.fetchData("main", "SimulationScheduler/UpdateVerification", "post", {}, data, xCancelSourceForGrid.current)
                errorMessages("Congratulations your account has been verified, continue to micro transit demonstration ");
                handleNext();
            }
        }
        else if(prevIndex == 2 && nextIndex == 3){
            if(selectedTime){
                let AddDemoTimeSlot = {
                    "recordID": demoUserRecordID,
                    "vSlotDuration": selectedTime,
                    "vStartTime": "",
                    "dtDemoDate": "",
                    "iNoOfVehicles": -1,
                    "iNoOfTripsPerVehicle": -1
                }
                let response = await APICom.fetchData("main", "SimulationScheduler/UpdateDemoDuration", "post", {}, AddDemoTimeSlot, xCancelSourceForGrid.current)
                if(response == undefined || response == null || response.data.result == "False"){
                    setUserMessage(response.data.Message);
                }
                else if(response != undefined && response != null && response.data.result == "True" && response.data.Record == "NILL"){
                    setUserMessage(response.data.Message + response.data.RemainingMinutes);
                }
                else{
                    wrapperUpdateSessionHeartBeat();
                    handleNext();
                }
            }else{
                errorMessages("Please select a time slot");
            }
        }
        else if(prevIndex == 3 && nextIndex == 4){
            //Save record for no of trips and no of vehicles
            let AddDemoTimeSlot = {
                "recordID": demoUserRecordID,
                "iNoOfVehicles": selectedVehiclesCount,
                "iNoOfTripsPerVehicle": selectedTripsPerVehiclesCount,
                "vStartTime": "",
                "dtDemoDate": "",
                "vSlotDuration": ""
            }
            let response = await APICom.fetchData("main", "SimulationScheduler/UpdateDemoDetails", "post", {}, AddDemoTimeSlot, xCancelSourceForGrid.current)
            if(response == undefined || response == null || response.data.result == "False"){
                setUserMessage(response.data.Message);
            }
            else
            {
                const latLngFromAddressComponent = latLngFromChildAddressComponent;
                if(latLngFromAddressComponent != undefined && latLngFromAddressComponent != null && latLngFromAddressComponent != ""){
                    setServiceLat(latLngFromAddressComponent.split(",")[0]);
                    setServiceLong(latLngFromAddressComponent.split(",")[1]);
                    setTspId(125);
                }
                if(backButtonPressed.current == false && rczManagementUIApplied.current == false){
                    setUISettingsForRCZManagementScreen();
                }
                else{
                    setDefaultSettings();    
                    rczManagementUIApplied.current = false;
                }
                handleNext();
            }
        }
        else {
            setDefaultSettings();
            handleNext();
        }
    };

    const setDefaultSettings = () => {
        try {
            setLoading(false);
            setOuterDivClass("setOuterDivDefault");
            setFooterClass("p-0 px-2 py-1");
            setModalFooterHTML(setFooterButtons(false));
            rczManagementUIApplied.current = false;
        } catch (error) {
            
        }
    }

    const setUISettingsForRCZManagementScreen = () => {
        try {
            setLoading(true);
            rczManagementUIApplied.current = true;
            setOuterDivClass("setOuterDivWhenRCZManagement");
            setFooterClass("setDialogFooterWhenRCZManagement");
            setModalFooterHTML(setFooterButtons());
        } catch (error) {
            
        }
    }

    const setFooterButtons = (IsRCZManagement = true) => {
        if(IsRCZManagement){
            return (
                <>
                    <Button variant="secondary" style={{backgroundColor:"#32728b"}} className="border-0" onClick={() => triggerPrevStep()}> Back </Button> 
                    <Button variant="secondary" style={{backgroundColor:"#32728b"}} className="border-0" onClick={() => triggerNextStep()} > Next </Button>
                </>
            )
        }
        else{
            return (
                <>
                </>
            )
        }
    }

    const updateSessionHeartBeat = async () => {
        try {
            let data = {
                "iUserRecordID": demoUserRecordID
            }
                let response = await APICom.fetchData("main", "SimulationScheduler/SessionHeartBeat", "post", {}, data, xCancelSourceForGrid.current)
                if(response == undefined || response == null || response.data.result == "False"){
                    setUserMessage("Unable to update Heart Beat.")
                }
                else{
                    wrapperUpdateSessionHeartBeat();
                }
        } catch (error) {
            updateSessionHeartBeat();
        }
    }

    const wrapperUpdateSessionHeartBeat = async () => {
        try {
            timeoutId.current = setTimeout(async () => {
                await updateSessionHeartBeat();
            }, 5000); //  5 seconds
        } catch (error) {
            
        }
    }

    const updateSimulationTimes = async () => {
        try {
            let data = {
                "iUserRecordID": demoUserRecordID
            }
                let response = await APICom.fetchData("main", "SimulationScheduler/StartSimulationTimes", "post", {}, data, xCancelSourceForGrid.current)
                if(response == undefined || response == null || response.data.result == "False"){
                    setUserMessage("Unable to start simulation, Contact Admin")
                }
                else{
                    handleDemoMTSchedulerLoginDialogClose();
                    openRMDashboardInNewTab();
                }
        } catch (error) {
            
        }
    }
    const openRMDashboardInNewTab = () => {
        try {
            window.location.href = SimulationDashboardURL;
            // window.open(SimulationDashboardURL, 'Simulation Dashboard');
        } catch (error) {
            
        }
    }

   

    const handleDesiredMilesChange = (e) => {
        const newValue = e.target.value;

        // Allow only numbers by using a regular expression
        if (/^\d*$/.test(newValue)) {
            setDesiredMilesValue(newValue);
        }
    };


  return (
    <>  
    <Modal show={props.showDemoMTSchedulerSignupProcess ? 1 : 0} centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
            }
          }} 
          onHide={handleDemoMTSchedulerLoginDialogClose} animation={true}  dialogClassName="modal-demoMTScheudlerLogin-width">
            <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{"Signup -Microtransit Simulation"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>
    <div style={{ display: 'flex',justifyContent:"center", backgroundColor:"#4a4d50"}}>
      
    </div>

    <div className={outerDivClass}>
        <FormWizard style={{display:'flex', float: "right"}} stepSize="xs" color="#32728b" onComplete={handleComplete} onTabChange={handleTabChange}
        backButtonTemplate={backTemplate} 
        nextButtonTemplate={(handleNext) => {
            handleNextRef.current = handleNext;
            backButtonPressed.current = false;
            return (
            <button className="base-button" onClick={() => handleNextStep(handleNext)}>
                Next
            </button>
            )
        }}
        finishButtonTemplate={(handleComplete) => (
          <button className="finish-button" onClick={handleComplete}>
            Start
          </button>
        )}
        >
        <FormWizard.TabContent title="Registration" icon="fa fa-user" >
    <Container>

      <Row>
        {
            userMessage && <h5 className="simulationUserWarningMsg">{userMessage}</h5>
        }
        
      </Row>  
      <Row>
     
        <Col md={6}><input placeholder="First Name *" className="firstName -dSim" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}/></Col>
        <Col md={6}><input placeholder="Last Name *" className="lastName -dSim" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}/></Col>
      </Row>
      <Row><Col>&nbsp;</Col></Row>
      <Row>
        <Col md={6}><input placeholder="Email *" className="email -dSim" type={"email"}  value={email} onChange={(e) => setEmail(e.target.value)}/></Col>
        <Col md={6}><input placeholder="Phone *" maxLength={10} pattern="\d{10}" className="phone -dSim" type="text" value={phone} onChange={(e) => setPhone(e.target.value)}/></Col>
      </Row>
      <Row><Col>&nbsp;</Col></Row>
      {/* <Row>
        <Col md={6}><input placeholder="Company Name" className="companyName -dSim" type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)}/></Col>
        <Col md={6}><input placeholder="Website URL" className="website -dSim" type="text" value={website} onChange={(e) => setWebsite(e.target.value)}/></Col>
      </Row>
      <Row><Col>&nbsp;</Col></Row>
      <Row>
        <Col md={12}><input placeholder="Comments/Notes" className="comments -dSim" type="text" value={comments} onChange={(e) => setComments(e.target.value)}/></Col>
      </Row> */}
    </Container>

        </FormWizard.TabContent>
            <FormWizard.TabContent title="Email Verification" icon="fa fa-envelope" isValid={checkValidateTab()} validationError={errorMessages}>
                {/* <h3>Email Verification</h3> */}
                <img src={EmailVerificationImg} alt="Email Verification" style={{height: '200px'}}/>
                <h3>We've sent an activation code to your email </h3>
                <h3 style={{color: "orange"}}>{email}</h3>
                <div className="center-content">
                    <VerificationInput validChars="0-9" length={4} inputProps={{inputMode: "numeric"}}  value={verificationCodeInput} onChange={(e) => setVerificationCodeInput(e)}/>
                </div>
            </FormWizard.TabContent>
            <FormWizard.TabContent title="Simulation Setup" icon="fa fa-clock" >
            {/* <h3>Demand Duration</h3> */}
                <Container>
                <Row>
                {
                    userMessage && <h5 className="simulationUserWarningMsg">{userMessage}</h5>
                }
                </Row>  
                    <Row>
                        <Col style={{height: "420px", padding: 0}}>
                         <Card style={{width: '100%', backgroundColor: "#F8F8F8"}} date={date}>
                                <Card.Body>
                                <Card.Title style={{ textAlign: 'left' }}>Duration</Card.Title>
                                <Form.Select  style={{borderRadius: "10px"}} onChange={handleDemoTimechange}>
                                     {/* {stateOptions && stateOptions.length > 0 ?  stateOptions.map((option, index) => ( */}
                                        {/* <option key={index} value={option.value}>{option.label}</option> */}
                                    {/* )): ""} */}
                                    <option key={1} value={30}>30 minutes</option>
                                    <option key={2} value={60}>60 minutes</option>
                                    <option key={3} value={90}>90 minutes</option>
                                    <option key={4} value={120}>120 minutes</option>
                                </Form.Select>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

        </FormWizard.TabContent>
        <FormWizard.TabContent title="Address Details for Simulation" icon="fa fa-clock" >
            {/* <h3>Address Details for Simulation</h3> */}
            <Container style={{display: "flex", justifyContent: "center",}}>
                <Row style={{display: "flex", justifyContent: "center", width: "100%"}}>
                <Row>
                {
                    userMessage && <h5 className="simulationUserWarningMsg">{userMessage}</h5>
                }
                </Row>  
                <Col md={12}>
                        <Card style={{width: '100%', backgroundColor: "#F8F8F8"}} date={date}>
                            <Card.Body>
                                {/* <Card.Title>Please provide some information then we are ready for your demo</Card.Title> */}
                                <Card.Subtitle style={{padding: "15px", paddingLeft: "0px", textAlign: "left"}}>
                                    Please enter your address
                                </Card.Subtitle>
                                <Col md={12}>
                                    <AddressSearch className="firstName -dSim" handlePUAddrChanged={handlePUAddrChanged} pickupAddr2={pickupAddr2} sendDataToParent={getLatLongDataFromChildAddressComponent}></AddressSearch></Col>
                                    {/* <input placeholder="Address" className="firstName -dSim" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}/></Col> */}
                                {/* <Form.Select  style={{borderRadius: "10px"}} onChange={handleStateChange}>
                                    {stateOptions && stateOptions.length > 0 ?  stateOptions.map((option, index) => (
                                        <option key={index} value={option.value}>{option.label}</option>
                                    )): ""}
                                </Form.Select> */}
                                <Card.Subtitle style={{padding: "15px",paddingLeft: "0px", textAlign: "left"}}>
                                    Enter your desired miles
                                </Card.Subtitle>
                                <Col md={12}><input placeholder="Desired Miles" className="firstName -dSim" type="number" value={desiredMilesValue} defaultValue={2} onChange={handleDesiredMilesChange}/></Col>
                                {/* <Card.Subtitle style={{padding: "15px",paddingLeft: "0px", textAlign: "left"}}>
                                       Service Area
                                </Card.Subtitle>
                                <Form.Select  style={{borderRadius: "10px"}} onChange={handleDemoTimechange}>
                                  
                                    <option key={1} value={30}>Red</option>
                                    <option key={2} value={60}>Purple</option>
                                    <option key={3} value={90}>Orange</option>
                                    <option key={4} value={120}>Yellow</option>
                                </Form.Select> */}
                                    <Card.Subtitle style={{padding: "15px",paddingLeft: "0px", textAlign: "left"}}>
                                        Select number of vehicle(s)
                                    </Card.Subtitle>
                                    <Form.Select aria-label="Vehicle number select" style={{borderRadius: "10px"}} onChange={handleDemoNoOfVehicles}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                    </Form.Select>
                                    <Card.Subtitle style={{padding: "15px",paddingLeft: "0px", textAlign: "left"}}>
                                        Select number of trips per vehicles
                                    </Card.Subtitle>
                                    <Form.Select aria-label="trip number select" style={{borderRadius: "10px"}} onChange={handleDemoNoOfTripsPerVehicle}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                    </Form.Select>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </FormWizard.TabContent>
            <FormWizard.TabContent title="Review Zone" icon="fa fa-border-none" className="setRCZManagementToFullScreen">
            <h3>Review Zone </h3>
            {loading && (
                <div className="rczManagementScreenloader">
                  {/* You can style or replace this with a spinner */}
                </div>
            )}
            <iframe className="setRCZManagementToFullScreen"  src={RCZManagementScreenURL + "&servicearealat="+ serviceLat + "&servicearealong=" + serviceLong + "&serviceareamileage=" + desiredMilesValue + "&iCustomerProfileID=" + demoUserRecordID} //+ "&tspid=" + tspid}
                style={{ border: 'none' }}
                title="RCZ Management"
                onLoad={() => setLoading(false)}
                allowFullScreen></iframe>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Start Simulation" icon="fa fa-flag-checkered" >
            <div className="simulationNoteDiv">
                <h3 className="simulationStartingNoteHeader">Note:</h3>
                <p className="simulationStartingNote">When you press the <b>Start button</b> it will redirect you to the <b>Microtransit Simulation Dashboard</b>. 
                This Dashboard will perform the simulation.If you accidently close the browser window you can open the link from your registered email.
                In case of any help you can contact ITCurves.
                </p>
            </div>
        </FormWizard.TabContent>
        </FormWizard>
     {/* add style */}
     <style>{`
       @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css");
       .react-form-wizard{
        width:88%;
       }
       
       .base-button {
        background-color: #32728b;
        border: none;
        color: white;
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        cursor: pointer;
        margin-right: 10px;
        margin-left: 10px;
        /* margin-top: 80px;*/
        border-radius: 10px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease;
        float:right;
        }
       
       .base-button:hover {
       background-color: #FAA61A;
       }
       
       .base-button:focus {
       outline: none;
       }
       
       .base-button:active {
       transform: translateY(2px);
       }

     .finish-button{
       background-color: green;
       border: none;
       color: white;
       padding: 15px 32px;
       text-align: center;
       text-decoration: none;
       display: inline-block;
       font-size: 16px;
       cursor: pointer;
       margin-right: 10px;
       margin-left: 10px;
       border-radius: 10px;
       box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
       transition: background-color 0.3s ease;
       float:right;
     }
     .finish-button:hover {
       background-color: darkgreen;
       }
     
     .finish-button:focus {
       outline: none;
      }
       
     .finish-button:active {
       transform: translateY(2px);
      }
      
    .center-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .stepTitle {
    font-size: 11px;
    }
    .list-group-item.active {
      background-color: #32728b !important; 
      border-color: #32728B !important;
      color: white;
    }


      `}</style>

      </div>
      </Modal.Body>
      {modalFooterHTML === ""? "":
              <Modal.Footer className={footerClass}>
                {modalFooterHTML}
              </Modal.Footer>
            }
      </Modal>
    </>
  );
}

export default DemoMTSchedulerSignupProcess;
